/* eslint-disable */
<template>
  <div id="instructor-home">
    <InstructorTableContainer v-if="['My-Bulbs','Classes','Folders','Students','Playlists', 'Premade-Bulbs','My-Videos'].includes(activeView)"></InstructorTableContainer>
  </div>
</template>

<script>
import {
  mapState,
  mapGetters,
  mapMutations,
} from 'vuex';
import InstructorSnapshotContainer from  '../instructor/InstructorSnapshotContainer';
import InstructorTableContainer from  '../instructor/InstructorTableContainer';
import storejs from 'store';
import axios from 'axios';

export default {
  name: 'instructor-home',
  components: {
    InstructorSnapshotContainer,
    InstructorTableContainer
  },
  computed: {
    ...mapState([
      'instructorData',
      'nodeApiPrefix',
      'school',
    ]),
    ...mapGetters([
      'activeView',
      'passbackLinking',
      'routerView',
      'snackbar',
    ]),
    ...mapGetters('instructors', [
      'activeViewInstructor',
      'queryParamsInstructors',
      'classes',
    ]),
    classesArchived() {
      return this.classes.archived;
    },
  },
  methods: {
    ...mapMutations([
      'triggerSnackbar',
    ]),
    async initializeLearnerExperienceBulbToast() {
      try {
        if (
          this.$inDevEnvironment()
          || !_.get(this, 'instructorData.token', '').length
          || !_.get(this, 'school.id')
          || sessionStorage.getItem('hasLearnerExperienceBulbToastAlreadyBeenTriggered')
          || this.passbackLinking
          || (
            _.get(this, 'snackbar.show')
            && _.get(this, 'snackbar.actionData.bulbId') === 1095778
          )
        ) return false;
        let learnerExperienceBulbToastLimit = storejs.get('learnerExperienceBulbToastLimit');
        if (!_.isFinite(learnerExperienceBulbToastLimit)) learnerExperienceBulbToastLimit = 5;
        if (!learnerExperienceBulbToastLimit) return false;
        const { data: bulbsCopiedFromLearnerExperienceBulb = [] } = await axios.get(
          `${this.nodeApiPrefix}/instructor/copies/1095778`,
          {
            headers: {
              Authorization: `Bearer ${this.instructorData.token}`,
            },
          },
        );
        if (bulbsCopiedFromLearnerExperienceBulb.length) {
          storejs.set('learnerExperienceBulbToastLimit', 0);
          return false;
        }
        window.sessionStorage.setItem('hasLearnerExperienceBulbToastAlreadyBeenTriggered', true);
        this.triggerSnackbar({
          text: 'Copy and assign The PlayPosit Learner Experience bulb to help introduce PlayPosit to your learners.',
          action: 'copyBulb',
          actionText: 'Copy',
          timeout: 0,
          color: 'success',
          actionData: {
            bulbId: 1095778,
            newBulbName: 'Copy of The PlayPosit Learner Experience',
            fullCopy: true,
            isCopyingUnrestricted: true,
          },
        });
        storejs.set('learnerExperienceBulbToastLimit', learnerExperienceBulbToastLimit - 1);
      } catch(e) {
        console.error(e);
      }
    },
  },
  watch: {
    activeViewInstructor(val, oldVal) {
      if ([
        'Bulbs',
        'Learners',
        'Bulb-Attempts',
        'Folders',
        'Folder',
        'Subfolder',
        'Gradebook',
        'Interactions',
        'Student-Bulb-Attempts',
        'Single-Interaction',
        'Student-Interaction',
        'My-Videos',
        'Learner-Made-Bulb',
        'Learner-Made-Bulb-Monitor',
        'Peer-Review',
      ].includes(val)) {
        this.$store.commit('instructors/setSelectedData', []);
        this.$store.dispatch('instructors/getTableData');
      } else if ([
        'Premade-Bulbs',
        'My-Community',
        'Premade-Bulbs-Legacy',
        'My-Community-Legacy',
      ].includes(val)) {
        this.$store.dispatch('instructors/getPremadeTableData', {});
      } else if (['My-Bulbs'].includes(val)) {
        this.initializeLearnerExperienceBulbToast();
      }
    },
    classesArchived(val, oldVal) {
      if (val !== oldVal) this.$store.dispatch('instructors/getTableData');
    },
  },
  async mounted() {
    await this.$nextTick();
    if (this.activeViewInstructor === 'My-Bulbs') this.initializeLearnerExperienceBulbToast();
  },
};
</script>

<style scoped>
#instructor-home {
  width: 100%;
  height: 100%;
}
</style>
